import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface PickupContactPageProp {
  shipment: Shipment;
}

export function ModifyShipmentPickupContactPage(_props: PickupContactPageProp) {
  return <Heading level={1}>Pickup Contact</Heading>;
}
